'use client';

import Link from 'next/link';
import Image from 'next/image';
import HeroBackgroundMosaic from './HeroBackgroundMosaic';
import logo from '../logo.png';

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* 背景：画像モザイク */}
      <HeroBackgroundMosaic />

      {/* 本体レイヤ（80%幅、白固定） */}
      <div className="relative z-10 w-4/5 mx-auto bg-white/50 rounded-lg px-6 pt-20 pb-12">
        <div className="flex flex-col items-center text-center">
          {/* ロゴのエッジのみを柔らかくぼかす */}
          <div className="flex items-center justify-center">
            <div className="inline-flex items-center rounded-md px-3 py-2">
              <Image
                src={logo}
                alt="AmiJ2株式会社 ロゴ"
                className="h-16 w-auto [filter:drop-shadow(0_0_12px_rgba(255,255,255,0.85))]"
              />
            </div>
          </div>

          <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold text-gray-900 tracking-tight">
            AI税理士 TaxMCP が、都税の悩みを即答解決。
          </h1>
          <p className="mt-4 text-lg text-gray-800 max-w-3xl">
            複雑な東京都税務の疑問も、チャットで聞くだけ。膨大な税務知識を持ったAIが、あなたのビジネスを停滞させる税の不安を、今すぐスマートに解消します。
          </p>

          <div className="mt-8 flex gap-4 justify-center">
            <Link
              href="/chat"
              aria-label="チャットを開始（チャットへ移動）"
              className="px-6 py-3 rounded-md bg-blue-700 text-white hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
            >
              チャットを開始
            </Link>
            <a
              href="#mcp"
              className="px-6 py-3 rounded-md bg-white text-blue-800 border border-blue-300 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
            >
              仕組みを見る
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-3 justify-center text-sm text-gray-700">
            <span className="inline-flex items-center gap-2 bg-white border rounded-full px-3 py-1">税理士監修</span>
            <span className="inline-flex items-center gap-2 bg-white border rounded-full px-3 py-1">東京都税務に特化</span>
            <span className="inline-flex items-center gap-2 bg-white border rounded-full px-3 py-1">AmiJ2株式会社</span>
          </div>
        </div>
      </div>
    </section>
  );
}
